module.exports = __webpack_public_path__ + "img/homeparticles.4b727439.webp";